/** Pre-made AI cover prompt phrases, in chip order. Copy lives in i18n under
 *  `editor.coverImage.ai.presets.<id>.{label,prompt}` — `label` is the chip,
 *  `prompt` the phrase added to the description. */
export const AI_COVER_PROMPT_PRESETS = [
  'clickworthy',
  'dramaticCloseUp',
  'bigTitle',
  'shocked',
  'vibrant',
  'cinematic',
  'highlightArrow',
  'minimal',
] as const;

export type AiCoverPromptPresetId = (typeof AI_COVER_PROMPT_PRESETS)[number];
